export default __webpack_public_path__ + "static/media/icon-rc.d84a3dd1.svg";